export default "__VITE_ASSET__C4Ld2tMr__"